<template>
    <div class="check-in-hotel">
        <div style="height: 0.41rem"></div>
        <Headbar
            :backgroundColor="'linear-gradient(180deg, #745BFF 0%, #463799 100%)'"
            :text="'入住酒店'"
        ></Headbar>
        <div class="warp" v-if="hotelState == 1 || hotelState == 0">
            <!-- 已安排酒店：展示酒店与入住、离店时间 -->
            <template v-if="!(status == 10 || status == 20)">
                <div class="warp-header">
                    <p>
                        <img src="@assets/hotel.png" alt="" />
                        <span class="van-multi-ellipsis--l2">{{ item.hotelName || '--' }}</span>
                    </p>
                    <p>
                        <span>{{ hotelStatusText }}</span>
                    </p>
                </div>
                <div class="check-in-time">
                    <div class="start">
                        <span class="time">{{ monthDayWeek(item.inTime) || '--' }}</span>
                        <span class="address">入住</span>
                    </div>
                    <div class="center">
                        <div class="transportation-mode">
                            <span></span>
                            <span>酒店</span>
                            <span></span>
                        </div>
                        <div class="vote-type">{{ days || '--' }}晚</div>
                    </div>
                    <div class="end">
                        <span class="time">{{ monthDayWeek(item.outTime) || '--' }}</span>
                        <span class="address">离店</span>
                    </div>
                </div>
            </template>

            <!-- 待安排：入住需求与计划入住时间段 -->
            <div v-if="status == 20 || status == 10" class="status-20-chunk">
                <div
                    class="coming-radio"
                    :style="{
                        padding:
                            hotelState == 0
                                ? '2.5rem 1.5rem 0.4rem 1.5rem'
                                : '0.5rem 1.5rem 0.4rem 1.5rem'
                    }"
                >
                    <van-radio-group v-model="hotelState" direction="horizontal">
                        <van-radio name="1">需要入住</van-radio>
                        <van-radio name="0">无需入住</van-radio>
                    </van-radio-group>
                </div>
                <!-- 需要入住：入住日期、离店日期（一次性选择时间段） -->
                <div v-if="hotelState === '1'" class="hotel-body">
                    <div class="title">请选择入住时间段</div>
                    <div class="row">
                        <span class="label">入住日期</span>
                        <span class="dash" style="color: #858a99">-</span>
                        <span class="label">离店日期</span>
                    </div>
                    <div class="row" style="margin: 0.4rem 0 0.6rem 0">
                        <span
                            class="date-value"
                            :class="{ placeholder: !checkIn }"
                            @click="openPicker"
                        >
                            {{ monthDayWeek(checkIn) || '请选择入住日期' }}
                        </span>
                        <span class="dash">-</span>
                        <span
                            class="date-value"
                            :class="{ placeholder: !checkOut }"
                            @click="openPicker"
                        >
                            {{ monthDayWeek(checkOut) || '请选择离店日期' }}
                        </span>
                    </div>
                </div>
                <div class="state-2-tips" v-if="hotelState == 0">您当前选择无需入住</div>
            </div>
        </div>
        <div class="warp" v-else>
            <div class="state-2-tips" v-if="hotelState == 0">您当前选择无需入住</div>
        </div>
        <van-popup
            v-model="showPicker"
            position="bottom"
            :style="{ width: contentWidth, left: contentLeft }"
        >
            <van-calendar
                v-if="showPicker"
                class="hotel-calendar"
                title="选择入住/离店日期"
                type="range"
                :min-date="pickerMinDate"
                :max-date="pickerMaxDate"
                :default-date="pickerDefaultDate"
                :allow-same-day="true"
                :poppable="false"
                :show-confirm="true"
                color="#0089ff"
                @confirm="onDateConfirm"
            />
        </van-popup>
        <!-- 无需入住二次确认（备注非必填） -->
        <no-need-dialog
            v-model="showNoNeedDialog"
            :title="'酒店入住'"
            :tip="'您是否确认【无需入住】服务？'"
            :handler="handleNoNeed"
        ></no-need-dialog>
    </div>
</template>

<script>
function pad (num) {
  return String(num).padStart(2, '0')
}

// 提交接口需要的日期格式 yyyy-MM-dd
function formatDate (date) {
  if (!date) return ''
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

// 手动拆解日期，避免 iOS Safari 解析 yyyy-MM-dd HH:mm:ss 出现 Invalid Date
function parseDate (value) {
  if (!value) return null
  if (value instanceof Date) return new Date(value.getTime())
  const match = String(value).trim().match(/(\d{4})[-/.年](\d{1,2})[-/.月](\d{1,2})/)
  if (!match) return null
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
  return isNaN(date.getTime()) ? null : date
}

// 日期展示：月日 周几，例如 11月2日 周日
function monthDayWeek (value) {
  const date = parseDate(value)
  if (!date) return ''
  const weeks = ['日', '一', '二', '三', '四', '五', '六']
  return `${date.getMonth() + 1}月${date.getDate()}日 周${weeks[date.getDay()]}`
}

import Headbar from './Headbar.vue'
import noData from '@components/Common/NoData.vue'
import NoNeedDialog from './NoNeedDialog.vue'
import itineraryMixin from './itineraryMixin'
import { mapGetters } from 'vuex'
export default {
  mixins: [itineraryMixin],
  components: {
    Headbar,
    noData,
    NoNeedDialog
  },
  props: {
    // 已安排的酒店信息（hotelName、inTime、outTime）
    item: {
      type: Object,
      default: () => ({})
    },
    // 酒店执行状态：10 无需入住 15 不安排 20 待安排 30 未入住 40 已入住 50 已离店
    status: {
      type: [String, Number],
      default: null
    },
    dictsCodeMap: {
      type: Object,
      default: () => ({})
    },
    // 酒店入住需求：1 需要入住 0 无需入住
    value: {
      type: [String, Number],
      default: null
    },
    // 计划入住、离店日期，直接使用接口返回值，不做自动回填
    checkIn: {
      type: String,
      default: ''
    },
    checkOut: {
      type: String,
      default: ''
    },
    // 大会开放可选的入住日期范围（Date 或 yyyy-MM-dd 字符串）
    minDate: {
      type: [Date, String],
      default: ''
    },
    maxDate: {
      type: [Date, String],
      default: ''
    }
  },
  data () {
    return {
      showPicker: false,
      showNoNeedDialog: false
    }
  },
  computed: {
    ...mapGetters(['contentWidth', 'contentLeft']),
    // 酒店执行状态文案
    hotelStatusText () {
      const text = (this.dictsCodeMap['guest_hotel_status'] || {})[this.status]
      return text === '待安排' ? '安排中' : text || ''
    },
    // 入住晚数
    days () {
      const start = parseDate(this.item.inTime)
      const end = parseDate(this.item.outTime)
      if (!start || !end) return null
      return Math.round((end - start) / (24 * 60 * 60 * 1000))
    },
    // 酒店入住需求，始终与接口值保持同步
    hotelState: {
      get () {
        if (this.value === null || this.value === undefined || this.value === '') return null
        return String(this.value)
      },
      set (val) {
        if (String(val) === String(this.value)) return
        // 需要入住：直接保存
        if (String(val) === '1') {
          this.saveNeedHotel()
          return
        }
        // 无需入住：二次确认弹窗，确认后才提交
        this.showNoNeedDialog = true
      }
    },
    // 日历可选范围起点（Date）
    pickerMinDate () {
      return parseDate(this.minDate) || new Date()
    },
    // 日历可选范围终点（Date），保证 >= 起点
    pickerMaxDate () {
      let max = parseDate(this.maxDate)
      if (!max) {
        max = new Date()
        max.setFullYear(max.getFullYear() + 1)
      }
      const min = this.pickerMinDate
      return max < min ? new Date(min.getTime()) : max
    },
    // 区间日历默认选中的入住、离店日期，未选择时不回填
    pickerDefaultDate () {
      const min = this.pickerMinDate
      const max = this.pickerMaxDate
      // default-date 必须落在可选范围内，否则日历会定位异常
      const clamp = date => {
        if (!date) return null
        if (date < min) return new Date(min.getTime())
        if (date > max) return new Date(max.getTime())
        return date
      }
      const start = clamp(parseDate(this.checkIn))
      const end = clamp(parseDate(this.checkOut))
      if (start && end && start <= end) return [start, end]
      if (start) return [start]
      return undefined
    }
  },
  methods: {
    monthDayWeek,
    // 选择需要入住：提交需求与已有的计划日期（不做自动回填）
    saveNeedHotel () {
      const payload = {
        hotelState: 1
      }
      if (this.checkIn) payload.plannedInTime = this.checkIn
      if (this.checkOut) payload.plannedOutTime = this.checkOut
      this.saveItinerary(payload, '入住酒店您已选择【需要入住】方式')
    },
    // 无需入住确认后提交需求与备注
    handleNoNeed (remark) {
      const payload = {
        hotelState: 0
      }
      if (remark) payload.hotelRemark = remark
      return this.saveItinerary(payload, '入住酒店您已选择【无需入住】方式')
    },
    // 入住和离店日期一次性选择时间段
    openPicker () {
      this.showPicker = true
    },
    onDateConfirm (dates) {
      this.showPicker = false
      const list = Array.isArray(dates) ? dates : [dates]
      if (!list[0] || !list[1]) return
      const plannedInTime = formatDate(list[0])
      const plannedOutTime = formatDate(list[1])
      if (plannedInTime === this.checkIn && plannedOutTime === this.checkOut) return
      this.saveItinerary({
        plannedInTime,
        plannedOutTime
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.check-in-hotel {
    .warp {
        margin-top: -1rem;
        background: #fff;
        padding: 0rem 0.29rem 0.21rem;
        border-radius: 0.41rem;
        .warp-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 1.64rem;
            p:nth-child(1) {
                display: flex;
                align-items: center;
                > img {
                    width: 0.74rem;
                    height: 0.74rem;
                    margin-right: 0.16rem;
                }
                > span {
                    font-size: 0.57rem;
                    font-weight: 500;
                    color: #162b40;
                }
            }
            p:nth-child(2) {
                display: flex;
                align-items: center;

                > span {
                    font-size: 0.57rem;
                    color: #0072f5;
                }
            }
        }

        .check-in-time {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 0.41rem;
            margin-top: 0.21rem;
            .start,
            .end {
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .time {
                    font-size: 0.66rem;
                    font-weight: 600;
                    color: #162b40;
                }
                .address {
                    margin-top: 0.28rem;
                    font-size: 0.49rem;
                    color: rgba(22, 43, 64, 0.85);
                }
            }
            .start {
                align-items: flex-start;
            }
            .end {
                align-items: flex-end;
            }
            .center {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .transportation-mode {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    > span {
                        display: flex;
                    }
                    span:nth-child(1) {
                        width: 0.74rem;
                        height: 0.04rem;
                        background: linear-gradient(
                            117deg,
                            rgba(0, 114, 245, 0),
                            rgba(1, 114, 245, 1)
                        );
                    }
                    span:nth-child(2) {
                        align-items: center;
                        justify-content: center;
                        width: 2.54rem;
                        height: 0.94rem;
                        background: rgba(0, 114, 245, 0.15);
                        border-radius: 0.69rem;
                        font-size: 0.49rem;
                        font-weight: 500;
                        color: #0072f5;
                        border: 0.04rem solid #0072f5;
                    }
                    span:nth-child(3) {
                        width: 0.74rem;
                        height: 0.04rem;
                        background: linear-gradient(
                            243deg,
                            rgba(0, 114, 245, 0),
                            rgba(0, 114, 245, 1)
                        );
                    }
                }
                .vote-type {
                    margin-top: 0.21rem;
                    font-size: 0.49rem;
                    color: rgba(34, 38, 37, 0.65);
                }
            }
        }
    }
    ::v-deep {
        .no-data {
            background: #fff;
            padding: 0.21rem 0 0;
            height: 4.56rem;
            overflow: hidden;
            border-radius: 0.41rem;
            > img {
                position: absolute;
                top: 0.21rem;
                left: 0;
                width: 100%;
                height: 4.56rem;
            }
            > span {
                color: #162b40;
            }
        }
    }
    .status-20-chunk {
        .coming-radio {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            min-height: 2.9rem;
            padding: 1.61rem 1.1rem 1rem 1.1rem;
            box-sizing: border-box;
        }

        .hotel-body {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 0 1rem;
            width: 100%;
        }
        .title {
            color: #15181d !important;
            font-size: 0.57rem;
            margin-bottom: 0.2rem;
        }
        .row {
            display: flex;
            align-items: center;
            gap: 0.4rem;
            justify-content: center;
            width: 100%;
        }

        .label {
            color: #858a99;
            font-size: 0.57rem;
            font-weight: 400;
            flex: 1;
            text-align: center;
        }

        .dash {
            color: #162b40;
            font-size: 0.8rem;
            font-weight: 500;
        }

        .date-value {
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1;
            color: #162b40;
            font-size: 0.57rem;
            font-weight: 500;

            background: #f5f9ff;
            border-radius: 0.16rem;

            min-width: 5rem;
            padding: 0.3rem 0.2rem;

            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
        }

        .date-value.placeholder {
            color: #b8c0cc;
            font-weight: 400;
        }
    }
    ::v-deep .van-radio-group--horizontal {
        width: 100% !important;
        justify-content: space-between !important;
    }
    /* 日历：非弹层模式需要显式高度 */
    ::v-deep .hotel-calendar {
        height: 62vh;
    }
    .state-2-tips {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.57rem;
        color: #535d6d !important;
        height: 5rem;
    }
}
</style>
